import React from 'react'
const Error = ()=>{
  return(
    <div style={{marginTop:'50px'}}>
      <h1>Error</h1>
    </div>
  )
}
export default Error;